import config from '../../../config';

export const cookieName = 'HTTP_COOKIE_HELPFUL_REVIEW_';

export const setCookie = (item, value) => {
  const expirationDate = new Date();
  expirationDate.setTime(
    expirationDate.getTime() +
      config.bazaarvoice.ageHelpfullReviewExpirationDays * 24 * 60 * 60 * 1000
  );
  document.cookie = `${cookieName}${item}=${value}; expires=" + ${expirationDate.toUTCString()} + "; path=/`;
};

export const readCookie = item => {
  const allcookies = document.cookie;
  const cookiearray = allcookies.split(';');

  let name = '';
  let value = '';
  for (let i = 0; i < cookiearray.length; i += 1) {
    name = cookiearray[i].split('=')[0];
    value = cookiearray[i].split('=')[1];
    if (name.trim() == `${cookieName}${item}`.trim()) {
      return value;
    }
  }
};

export const deleteCookie = (item) => {
  document.cookie = `${cookieName}${item}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};
